import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { UserCheck, UserX, UserPlus } from "lucide-react";

interface ReviewAttendeesTabProps {
  data: any;
}

export function ReviewAttendeesTab({ data }: ReviewAttendeesTabProps) {
  return (
    <div className="space-y-6">
      {/* Present Members */}
      <Card className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <UserCheck className="h-5 w-5 text-green-600" />
          <h3 className="font-semibold">Members Present ({data.actual_attendees.length})</h3>
        </div>
        
        {data.actual_attendees.length > 0 ? (
          <div className="grid gap-3">
            {data.actual_attendees.map((attendee: any, index: number) => (
              <div key={index} className="flex items-center justify-between p-3 border rounded-lg">
                <div>
                  <p className="font-medium">{attendee.member_name}</p>
                  <p className="text-sm text-muted-foreground">{attendee.member_role}</p>
                </div>
                {attendee.checked_in_at && (
                  <Badge variant="outline">
                    Checked in: {new Date(attendee.checked_in_at).toLocaleTimeString()}
                  </Badge>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground">No attendees recorded</p>
        )}
      </Card>

      {/* Absent Members */}
      {data.absent_members && data.absent_members.length > 0 && (
        <Card className="p-6">
          <div className="flex items-center gap-2 mb-4">
            <UserX className="h-5 w-5 text-red-600" />
            <h3 className="font-semibold">Absent Members ({data.absent_members.length})</h3>
          </div>
          
          <div className="grid gap-3">
            {data.absent_members.map((member: any, index: number) => (
              <div key={index} className="flex items-center justify-between p-3 border rounded-lg bg-muted/50">
                <div>
                  <p className="font-medium">{member.member_name}</p>
                  <p className="text-sm text-muted-foreground">{member.member_role}</p>
                </div>
                <Badge variant="outline">Absent</Badge>
              </div>
            ))}
          </div>
        </Card>
      )}

      {/* Special Guests */}
      {data.special_guests && data.special_guests.length > 0 && (
        <Card className="p-6">
          <div className="flex items-center gap-2 mb-4">
            <UserPlus className="h-5 w-5 text-blue-600" />
            <h3 className="font-semibold">Special Guests ({data.special_guests.length})</h3>
          </div>
          
          <div className="grid gap-3">
            {data.special_guests.map((guest: any, index: number) => (
              <div key={index} className="flex items-center justify-between p-3 border rounded-lg">
                <div>
                  <p className="font-medium">{guest.name}</p>
                  {guest.title && (
                    <p className="text-sm text-muted-foreground">{guest.title}</p>
                  )}
                </div>
                <Badge variant="secondary">Guest</Badge>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
